import { Link, useLocation } from 'react-router';
import type { KombiRouteMap } from './productionRoutes';
import './FloatingShareAction.css';

type ShareRoutes = Pick<KombiRouteMap, 'shareAutomation' | 'shareAutomationStep'>;

/**
 * The journey entry is `/share` in production and the matching visual-review journey elsewhere.
 * A path check, not an extra session read, prevents the action from linking back into the journey a
 * person is already completing.
 */
export function isShareJourneyPath(pathname: string, routes: ShareRoutes): boolean {
  const entry = routes.shareAutomationStep('select').split('?')[0] ?? routes.shareAutomation;
  const root = entry.endsWith('/select') ? entry.slice(0, -'/select'.length) : entry;
  return pathname === root || pathname.startsWith(`${root}/`);
}

/** One authenticated-shell action, shared by Kombi and legacy Trailblazer routes. */
export function FloatingShareAction({ routes }: { routes: ShareRoutes }) {
  const { pathname } = useLocation();
  if (isShareJourneyPath(pathname, routes)) return null;

  return (
    <Link aria-label="Share a tool" className="floating-share-action" to={routes.shareAutomation}>
      <svg aria-hidden="true" fill="none" viewBox="0 0 24 24">
        <path d="M12 19V5M6.5 10.5 12 5l5.5 5.5" />
      </svg>
      <span aria-hidden="true" className="floating-share-action-label">
        Share a tool
      </span>
    </Link>
  );
}
